import React from "react"
import Icon from "../Icon/Icon"
import ReactTooltip from "react-tooltip"

export default function CallbacksFields({
	endUserConfigUrl,
	findEndUsersUrl,
	bankingPageUrl,
	updateSettings,
}: {
	endUserConfigUrl?: string
	findEndUsersUrl?: string
	bankingPageUrl?: string
	updateSettings: (field: string, value: string) => void
}) {
	return (
		<fieldset className="fields">
			<div className="field">
				<label className="label label-with-tooltip">
					Application Prefill Endpoint
					<div data-tip="React-tooltip" data-for="application-prefill-info" className="tooltip-info">
						<Icon icon="information-circle--interface-essential" size={12} />

						<ReactTooltip className="tooltip-info" id="application-prefill-info" effect="solid">
							https://www.unit.co/docs/ready-to-launch/banking/implementation/#pre-filling-end-user-information-recommended
						</ReactTooltip>
					</div>
				</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={endUserConfigUrl ?? ""}
						onChange={(e) => {
							updateSettings("endUserConfigUrl", e.target.value)
						}}
					/>
				</div>
			</div>
			<div className="field">
				<label className="label label-with-tooltip">
					User Management Endpoint
					<div data-tip="React-tooltip" data-for="user-management-info" className="tooltip-info">
						<Icon icon="information-circle--interface-essential" size={12} />

						<ReactTooltip className="tooltip-info" id="user-management-info" effect="solid">
							https://www.unit.co/docs/ready-to-launch/banking/implementation/#inviting-additional-users-to-banking-optional
						</ReactTooltip>
					</div>
				</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={findEndUsersUrl ?? ""}
						onChange={(e) => {
							updateSettings("findEndUsersUrl", e.target.value)
						}}
					/>
				</div>
			</div>
			<div className="field">
				<label className="label label-with-tooltip">Banking Page URL</label>
				<div className="control">
					<input
						className="input"
						type="text"
						placeholder="Enter URL"
						value={bankingPageUrl ?? ""}
						onChange={(e) => {
							updateSettings("bankingPageUrl", e.target.value)
						}}
					/>
				</div>
			</div>
		</fieldset>
	)
}
